export const isCreditEntry = (entry) => entry?.entry_type === "credit";

export const creditReasonLabel = (reason) => ({
  referral: "Werbeprogramm",
  marketing: "Marketing",
  other: "Sonstiges",
}[reason] || "Gratis-Monate");

export const creditStatusLabel = (status) => ({
  pending: "Vorgemerkt",
  applied: "Eingebucht",
  voided: "Storniert",
}[status] || status);

export const billingEntryTitle = (entry) => {
  if (isCreditEntry(entry)) {
    return `${entry.months || 0} ${entry.months === 1 ? "Gratis-Monat" : "Gratis-Monate"}`;
  }
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" })
    .format(entry?.betrag || 0);
};

export const billingEntryTimestamp = (entry) => (
  isCreditEntry(entry) ? entry.created_at : (entry.bezahlt_am || entry.created_at)
);
